module.exports = __webpack_public_path__ + "static/single-leader-replication-9437d23d4b43953f26965d8406471ca8.png";